/* eslint-disable camelcase */
import { createAxiosInstance, generateVaultApiUrl } from 'utils/Api';
import { RakeWeighterExecution } from 'utils/rakeWeighterExecutions';

const apiUrl = generateVaultApiUrl('/api/v2/rake_weighter_executions/');
const axiosInstance = createAxiosInstance(apiUrl);

interface RequestParams {
  survey_group: number;
  zc_client_id?: string;
  display_on_dashboard?: boolean;
}

/**
 * Get the date ranges for a client's community survey cadence.
 */
export async function fetchRakeWeighterExecutions(allParams: RequestParams): Promise<RakeWeighterExecution[]> {
  const { zc_client_id, ...params } = allParams;
  const result = await axiosInstance.get<RakeWeighterExecution[]>('', {
    params: { ...params, bypass_client_filter: true },
    ...(zc_client_id && {
      headers: {
        'X-Zc-Client-Id': zc_client_id,
      },
    }),
  });

  return result.data;
}
